import React, { useEffect, useState } from "react";
import "./App.css";
import airports from "./data/airports-sml-sorted.json";
import Autosuggest from "react-autosuggest";

const darkStyles = [
  { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#263c3f" }],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [{ color: "#6b9a76" }],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#38414e" }],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: "#212a37" }],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9ca5b3" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#746855" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#1f2835" }],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [{ color: "#f3d19c" }],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{ color: "#2f3948" }],
  },
  {
    featureType: "transit.station",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#17263c" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#515c6d" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#17263c" }],
  },
];

const getSuggestions = (value) => {
  const inputValue = value.trim().toLowerCase();
  const rawMatchTries = 10;

  const searchFields = ["iata_code", "municipality", "name", "local_code"];

  const sortByFrequency = (array) => {
    let frequencies = new Map([...new Set(array.map((ap) => [ap.name, 0]))]);
    array.forEach((value) => {
      frequencies.set(value.name, frequencies.get(value.name) + 1);
      console.log({ key: value.name, newCount: frequencies.get(value.name) });
    });
    const sortedFrequencies = [...frequencies.entries()].sort(
      (a, b) => b[1] - a[1]
    );
    console.log({ sortedFrequencies });
    return sortedFrequencies.map((pair) =>
      array.find((airport) => airport.name === pair[0])
    );
  };

  let matches = [];

  searchFields.forEach((fieldName) => {
    let fieldMatches = 0;
    if (
      fieldMatches < rawMatchTries &&
      matches.length < rawMatchTries * searchFields.length
    ) {
      airports.forEach((airport) => {
        if (
          fieldMatches < rawMatchTries &&
          airport[fieldName].toLowerCase().indexOf(inputValue) >= 0
        ) {
          matches.push(airport);
          fieldMatches++;
        }
      });
    }
    console.log({ fieldMatches: matches });
  });
  console.log({ matches });
  return sortByFrequency(matches);
};

const prettyName = (suggestion) =>
  `[${suggestion.local_code || suggestion.iata_code}] ${suggestion.name} (${
    suggestion.municipality
  })`;

const getSuggestionValue = (suggestion) => prettyName(suggestion);
const renderSuggestion = (suggestion) => <span>{prettyName(suggestion)}</span>;

const latLng = (selection) => {
  return {
    lat: parseFloat(selection.lat),
    lng: parseFloat(selection.lng),
  };
};
function App() {
  const [searchValue, setSearchValue] = useState("");
  const [selection, setSelection] = useState({});
  const [suggestions, setSuggestions] = useState([]);
  const [darkMode, setDarkMode] = useState(false);
  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    if (window.google && window.google.maps) {
      if (darkMode) {
        console.log("setting styles");
        window.map.setOptions({ styles: darkStyles });
      } else {
        console.log("clearing styles");
        window.map.setOptions({ styles: [] });
      }
      if (!markers.includes(selection && selection.id)) {
        window.markers.push(
          new window.google.maps.Marker({
            position: latLng(selection),
            map: window.map,
            title: prettyName(selection),
          })
        );
      }
    }
  }, [darkMode, markers, selection]);

  const onChange = (event, { newValue }) => {
    console.log({ event, newValue });
    setSearchValue(newValue);
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value));
  };

  const onSuggestionSelected = (event, { suggestion }) => {
    console.log({ suggestion });
    const latLng = {
      lat: parseFloat(suggestion.lat),
      lng: parseFloat(suggestion.lng),
    };
    window.rangeCircle.setCenter(latLng);
    window.map.fitBounds(window.rangeCircle.getBounds());
    setSelection(suggestion);
    setMarkers([...markers, selection.id]);
    console.log({ suggestion });
  };
  const onSuggestionsClearRequested = () => setSuggestions([]);
  // Autosuggest will pass through all these props to the input.
  const inputProps = {
    placeholder: "Enter airport",
    value: searchValue,
    onChange,
  };

  return (
    <div className="App">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap"
        }}
      >
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          onSuggestionsClearRequested={onSuggestionsClearRequested}
          onSuggestionSelected={onSuggestionSelected}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
        />

        {/* <button
          onClick={() => {
            setSearchValue("");
          }}
        >
          Clear Search
        </button> */}

        <button
          className="clearButton"
          onClick={() => {
            window.markers.forEach((marker) => marker.setMap(null));
            window.rangeCircle.setCenter({ lat: -999, lng: -999 });
            setMarkers([]);
            setSelection({});
            setSearchValue("");
          }}
          disabled={ markers.length === 0 && Object.keys(selection).length === 0 && searchValue === ""}
        >
          Clear
        </button>
        {/* <button
          onClick={() => {
            window.rangeCircle.setCenter({ lat: -999, lng: -999 });
          }}
        >
          Hide Range
        </button>
        <button
          onClick={() => {
            setMarkers([]);
            window.markers.forEach((marker) => marker.setMap(null));
          }}
        >
          Clear Other Markers
        </button>
        <button onClick={() => setDarkMode(!darkMode)}>
          {darkMode ? "Disable Dark Mode" : "Enable Dark Mode"}
        </button> */}

      </div>
      <div>
        {Math.ceil(window.range * 0.000539957)} nautical miles ({window.range / 1000}km)<br />
      </div>

    </div>
  );
}

export default App;
